// Client-side helpers for user management. The server is authoritative on all of these; the
// client-side checks are UX — they prevent a round trip the API would refuse.

export function countAdmins(users) {
  return users.filter((u) => u.active && u.roles.includes('ADMIN')).length;
}

export function isLastAdmin(users, email) {
  const admins = users.filter(
    (u) => u.active && u.roles.includes('ADMIN') && u.email !== email,
  );
  return admins.length === 0;
}

export function wouldRemoveLastAdmin(users, email, newRoles, newActive) {
  const user = users.find((u) => u.email === email);
  if (!user) return false;
  if (!user.roles.includes('ADMIN')) return false;
  const losing = !newRoles.includes('ADMIN') || !newActive;
  return losing && isLastAdmin(users, email);
}

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validateUserForm({ firstName, lastName, email, roles, domain }) {
  const errors = {};
  if (!firstName.trim()) errors.firstName = 'First name is required';
  if (!lastName.trim()) errors.lastName = 'Last name is required';
  if (!email.trim()) errors.email = 'Email is required';
  else if (!EMAIL_RE.test(email.trim())) errors.email = 'Invalid email format';
  else if (domain && !email.trim().toLowerCase().endsWith(`@${domain}`))
    errors.email = `Email must be a @${domain} address`;
  if (roles !== undefined && roles.length === 0) errors.roles = 'At least one role is required';
  return errors;
}

export function buildPayload({ firstName, lastName, email, roles, active }) {
  return {
    first_name: firstName.trim(),
    last_name: lastName.trim(),
    email: email.trim().toLowerCase(),
    roles,
    ...(active !== undefined ? { active } : {}),
  };
}
